import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { ConfigFieldControl, ConfigTextField, PageTemplate, PageTemplateDashboard, PageTemplateHeader, PageTemplateHeaderActions } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import SlotRenderer from '../renderers/SlotRenderer';
import { SiteComponent } from '../SiteComponentPlugin';
const StyledPageTemplate = styled(PageTemplate) `
  .page-template-dashboard.board-view {
    padding: 0;
  }
`;
export const SiteKanbanBoardPage = props => {
    var _a;
    const component = useSubscribeComponentChanges(SiteKanbanBoardPagePlugin, props);
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteKanbanBoardPagePlugin }, props),
        React.createElement(StyledPageTemplate, null,
            React.createElement(PageTemplateHeader, null,
                React.createElement(Typography, { variant: 'h2' }, (_a = component.props) === null || _a === void 0 ? void 0 : _a.heading),
                React.createElement(PageTemplateHeaderActions, { flex: true },
                    React.createElement(SlotRenderer, { component: component, slot: 'header-actions' }))),
            React.createElement(PageTemplateDashboard, { className: 'board-view' },
                React.createElement(SlotRenderer, { component: component, slot: 'kanban-board' })))));
};
export const SiteKanbanBoardPageConfigurator = props => {
    var _a;
    const { component } = props;
    const { update } = useConfigComponent(component);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Heading', value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.heading) || '', onChange: event => update('props.heading', event.target.value) }))));
};
export const SiteKanbanBoardPagePlugin = {
    name: 'Site Kanban Board Page',
    type: 'site-kanban-board-page',
    component: SiteKanbanBoardPage,
    configurator: SiteKanbanBoardPageConfigurator,
    slots: [
        {
            name: 'Header Actions',
            type: 'component-stack',
            slot: 'header-actions'
        },
        {
            name: 'Kanban Board',
            type: 'site-kanban-board',
            slot: 'kanban-board'
        }
    ]
};
//# sourceMappingURL=SiteKanbanBoardPagePlugin.js.map